module.exports = __webpack_public_path__ + "static/media/section-two@2x.c11719a9.png";